import { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const useStreak = (userId) => {
  const [streak, setStreak] = useState(0);
  const [longestStreak, setLongestStreak] = useState(0);
  const [studiedToday, setStudiedToday] = useState(false);

  useEffect(() => {
    if (!userId) return;
    fetchStreak();
  }, [userId]);

  const fetchStreak = async () => {
    try {
      const ref = doc(db, 'streaks', userId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        const today = new Date().toDateString();
        const yesterday = new Date(Date.now() - 86400000).toDateString();
        if (data.lastStudied === today) {
          setStreak(data.currentStreak || 0);
          setStudiedToday(true);
        } else if (data.lastStudied === yesterday) {
          setStreak(data.currentStreak || 0);
          setStudiedToday(false);
        } else {
          setStreak(0);
          setStudiedToday(false);
        }
        setLongestStreak(data.longestStreak || 0);
      }
    } catch (err) { console.error('streak fetch failed', err); }
  };

  const recordStudy = async () => {
    if (!userId) return;
    try {
      const ref = doc(db, 'streaks', userId);
      const snap = await getDoc(ref);
      const today = new Date().toDateString();
      const yesterday = new Date(Date.now() - 86400000).toDateString();
      let currentStreak = 1;
      let longestStreakVal = 1;
      if (snap.exists()) {
        const data = snap.data();
        if (data.lastStudied === today) return;
        if (data.lastStudied === yesterday) {
          currentStreak = (data.currentStreak || 0) + 1;
        }
        longestStreakVal = Math.max(currentStreak, data.longestStreak || 0);
      }
      await setDoc(ref, {
        currentStreak,
        longestStreak: longestStreakVal,
        lastStudied: today,
        userId,
      });
      setStreak(currentStreak);
      setLongestStreak(longestStreakVal);
      setStudiedToday(true);
    } catch (err) { console.error('streak record failed', err); }
  };

  return { streak, longestStreak, studiedToday, recordStudy };
};

export default useStreak;
